import Swiper, { Scrollbar, Pagination } from 'swiper'
import 'ion-rangeslider'

Swiper.use([Scrollbar, Pagination])

if ($('.js-costTableSlider').length > 0) {
  const costTableSlider = new Swiper('.js-costTableSlider .swiper-container', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    pagination: {
      el: '.js-costTableSlider .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    scrollbar: {
      el: '.js-costTableSlider .swiper-scrollbar',
      draggable: true,
    },
    on: {
      slideChange() {
        const { activeIndex } = this

        setActiveSlideClassName(activeIndex)
        changeRangeSliders(activeIndex)
      },
    },
  })

  $(document).on('click', '.js-costTableSlider .swiper-slide', (e) => {
    const activeIndex = $(e.currentTarget).index()

    costTableSlider.slideTo(activeIndex)
    setActiveSlideClassName(activeIndex)
    changeRangeSliders(activeIndex)
  })

  const costStickySlider = new Swiper('.js-costStickySlider .swiper-container', {
    spaceBetween: 10,
    slidesPerView: 'auto',
  })

  $(window).on('load resize', () => {
    const heightArrays = []
    const $cols = $(window).width() >= 768
      ? $('.js-costTableCol')
      : $('.js-costTableCol:not(:first)')

    $cols.each(function () {
      $(this)
        .find('> div')
        .each(function () {
          const _thisIndex = $(this).index()

          $(this).removeAttr('style')

          if (heightArrays[_thisIndex]) {
            if ($(this).outerHeight() > heightArrays[_thisIndex]) {
              heightArrays[_thisIndex] = $(this).height()
            }
          } else {
            heightArrays.push($(this).outerHeight())
          }
        })
    })

    $cols.each(function () {
      $(this)
        .find('> div')
        .each(function (i) {
          $(this).height(heightArrays[i])
        })
    })

    costTableSlider.update(true)
  })

  const costRangeSlider = $('.js-costRangeSlider')
    .ionRangeSlider({
      type: 'single',
      min: $(this).data('min'),
      max: $(this).data('max'),
      from: $(this).data('from'),
      force_edges: true,
      hide_from_to: true,
      hide_min_max: true,
      onChange(data) {
        const { from } = data

        setActiveSlideClassName(from)
      },
      onFinish(data) {
        const { from } = data
        costStickyRangeSlider.update({
          from,
        })
      },
    })
    .data('ionRangeSlider')
  
    let values = ['50', '150', '300', '500', '1000', '1500', '1500+']

    if (typeof sliderRangeValues !== 'undefined') {
      values = sliderRangeValues
    }

  const costStickyRangeSlider = $('.js-costStickyRangeSlider')
    .ionRangeSlider({
      type: 'single',
      min: $(this).data('min'),
      max: $(this).data('max'),
      from: $(this).data('from'),
      force_edges: true,
      hide_min_max: true,
      values: values,
      onChange(data) {
        const { from } = data
        setActiveSlideClassName(from)
      },
      onFinish(data) {
        const { from } = data
 
        costRangeSlider.update({
          from,
        })
      },
    })
    .data('ionRangeSlider')

  setActiveSlideClassName(2)

  function setActiveSlideClassName(index) {
    $('.js-costTableSlider .swiper-slide')
      .eq(index)
      .addClass('is_active')
      .siblings()
      .removeClass('is_active')
    $('.js-costStickySlider .swiper-slide')
      .eq(index)
      .addClass('is_active')
      .siblings()
      .removeClass('is_active')
    costTableSlider.slideTo(index)
    costStickySlider.slideTo(index)
  }

  function changeRangeSliders(activeIndex) {
    if (costRangeSlider) {
      costRangeSlider.update({
        from: activeIndex,
      })
    }

    if (costStickyRangeSlider) {
      costStickyRangeSlider.update({
        from: activeIndex,
      })
    }
  }

  $(window).on('scroll load resize', () => {
    const scrolled = $(window).scrollTop()
    const tableWrapperTop = $('.cost-table-wrapper').offset().top
    const tableHeight = tableWrapperTop + ($('.cost-table-wrapper').height() - 250)

    if (scrolled > tableWrapperTop && scrolled < tableHeight) {
      $('.cost-sticky').addClass('is_visible')
    } else {
      $('.cost-sticky').removeClass('is_visible')
    }
  })
}
